// import { EventsComponent } from './events/events.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CoursesComponent } from './courses/courses.component';
import { PlacementComponent } from './placement/placement.component';
// import { CareerComponent } from './career/career.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { VerifyCertificateComponent } from './verify-certificate/verify-certificate.component';
import { CertificateComponent } from './certificate/certificate.component';
import { CourseDetailComponent } from './courses/course-detail/course-detail.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { ThankYouComponent } from './thank-you/thank-you.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'courses', component: CoursesComponent },
  { path: 'courses/:courseName', component: CourseDetailComponent },
  // { path: 'events', component: EventsComponent },
  { path: 'placement', component: PlacementComponent },
  // { path: 'career', component: CareerComponent },
  { path: 'blog', loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule) },
  { path: 'contact', component: ContactComponent },
  { path: 'certificate', component: CertificateComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  { path: 'thank-you', component: ThankYouComponent },
  
  // Location-based routes (e.g., /hnm/courses, /hnm/contact)
  { path: ':location/home', component: HomeComponent },
  { path: ':location/about', component: AboutComponent },
  { path: ':location/courses', component: CoursesComponent },
  { path: ':location/courses/:courseName', component: CourseDetailComponent },
  { path: ':location/placement', component: PlacementComponent },
  { path: ':location/contact', component: ContactComponent },
  { path: ':location/certificate', component: CertificateComponent },
  
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
